import React, { useEffect } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import withRouter from 'src/config/withRouter';
import { connect } from 'react-redux';
import { remove_user, change_lang } from 'src/store/action';
// firebase
import { Accordion, AccordionSummary, AccordionDetails, useMediaQuery } from '@mui/material';
import Drawer from '@mui/material/Drawer';
import Checkbox from '@mui/material/Checkbox';
import withStyles from '@mui/styles/withStyles';
import { ArrowBack, ArrowForward, ExpandMore } from '@mui/icons-material';
import { withTranslation } from 'react-i18next';

import VideoLogo from 'src/assets/images/content/menuVideo.svg';
import DocLogo from 'src/assets/images/content/menuDoc.svg';
import QuizLogo from 'src/assets/images/quiz/quiz.svg';
import LinkLogo from 'src/assets/images/content/menuLink.svg';
import { theme } from 'src/screens/WhiteLabels/Templates/Template1/Template';

const drawerWidth = 307;

const StyledCheckbox = withStyles({
    root: {
      color: '#36ABEF',
      '&$checked': {
        color: '#36ABEF',
      },
    },
    disabled:{
        color: '#36ABEF !important',
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const useStyles = makeStyles((theme) => ({
    drawer: {
        width: drawerWidth,
        flexShrink: 0,

        [theme.breakpoints.between('xs','md')]: {
            width:'100%',
            // height:'calc(100% - 375px)'
        }
    },
    drawerPaper: {
        width: drawerWidth,
        top:'60px',
        height:'calc(100% - 60px)',
        backgroundColor:'#0D273E',
        color:'#B5BDCE',
        fontFamily: props => props.fontFamily,

        "&::-webkit-scrollbar": {
            width: '3px'
        },

        [theme.breakpoints.between('xs','md')]: {
            width:'100%',
            position:'unset !important',
            height:'unset'
        }
        
    },

    pointerEvent:{
        PointerEvent: 'none'
    },

    rowDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between'
    },

    backBtn:{
        outline:'none',
        border:'1px solid #36ABEF',
        backgroundColor:'transparent',
        color:'#36ABEF',
        padding:'3px',
        cursor:'pointer',
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'center'
    },

    drawerTitle:{
        fontSize:'14px',
        color:'#fff',
        fontWeight:500
    },

    contentCard:{
        padding:'10px 21px',
        borderBottom:'0.5px solid #36ABEF',
        width:'calc(100% - 42px)',
        cursor:'pointer',

        '&:hover':{
            backgroundColor:'#123950'
        },
        '&:focus':{
            backgroundColor:'#123950'
        }
    },

    contentDiv:{
        width:'calc(100% - 42px)',
        justifyContent:'flex-start',
        alignItems:'flex-start'
    },

    contentName:{
        fontSize:'12px',
        textTransform:'capitalize',
        padding:'0px 10px',
        width:'calc(100% - 37px)',
        overflow:'hidden',
        textOverflow:'ellipsis',
        whiteSpace:'nowrap'
    },

    fileIcon:{
        width:'17px',
        height:'17px',

        '& img':{
            width:'100%',
            height:'100%'
        }
    },

    sectionRender:{
        display:'flex',
        flexDirection:'column',
        overflow:'scroll',
        height:'100%',
        [theme.breakpoints.between('xs','md')]: {
            overflow:'scroll',
            // maxHeight:'200px'
        }
    }
}));

const accordionUseStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        padding: '0px',
        margin: '2px auto 0px auto',
        backgroundColor:'transparent',
        borderRadius:'0px'
    },

    header:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between',
        width:'100%',

        '& span':{
            fontSize: '14px',
            fontWeight: 500,
            color:'#fff',
            textTransform:'capitalize',
            maxWidth: '250px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',

            [theme.breakpoints.down('sm')]: {
                maxWidth:'150px'
            }
        },

        "& button":{
            cursor:'pointer'
        }
    },

    accordionRoot:{
        boxShadow:'none',
        border:'none',
        borderRadius:'0px !important',
        backgroundColor:'transparent',
        color:'#fff'
    },

    marLeft:{
        marginLeft:'10px'
    },

    marRight:{
        marginRight:'10px'
    },

    accSumRoot:{
        backgroundColor:'#174F81',
        minHeight:'30px',
        padding:'0px',
        borderRadius:'0px',
        color:'#fff',
        padding:'0px 21px 0px 30px'
    },

    expandIcon:{
        color:'#fff'
    },

    accContent:{
        margin:'0px'
    },

    expandedCls:{
        margin:'0px !important',
        minHeight:'30px !important'
    },

    accDetail:{
        padding:'0px',
        backgroundColor:'transparent'
    }
}));

function ContentSideMenu(props) {
    const isMounted = React.useRef(null);
    const { t, i18n, expandId, setExpandId, courseData, courseContents, contentLogs, history, sideMenuContentClick, activeContentId, customCls, mobileCloseDrawerEvent,singleSession } = props;
    const isRTL = i18n.translator.language;
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL === 'ar' ? ar : en;
    const classes = useStyles({fontFamily,isRTL});
    const matches = useMediaQuery(theme.breakpoints.down('md'));


    useEffect(()=> {
        isMounted.current = true;
        function scroll(){   
            const activePath = window.location.pathname;
            if(activePath && document.getElementById(activePath)) {
                document.getElementById(activePath).scrollIntoView({
                    behavior: 'smooth'
                });
            }
        };

        scroll();
        return () => isMounted.current = false;
    },[])

    const filterSections = courseData && courseData?.['Sections']?.length ? courseData?.['Sections']?.filter(v=> v.visible) : [];

  return (
      <Drawer
        className={`${classes.drawer} ${customCls || ''}`}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor={isRTL === 'ar' ? 'right' : 'left'}
        dir={isRTL === 'ar' ? 'rtl' : 'ltr'}
      >
        <>
        <div className={classes.rowDiv} style={{padding:'10px 5px'}}>
            <span className={classes.drawerTitle} style={{fontFamily}}>{t('coursePage.courseContent')}</span>
            <button className={classes.backBtn} onClick={()=> matches ? mobileCloseDrawerEvent() : history.goBack()}>{isRTL === 'ar' ? <ArrowForward /> : <ArrowBack />}</button>
        </div>

        <div className={classes.sectionRender}>
        {filterSections?.length ? React.Children.toArray(filterSections.map(val=> {
            return(
                <CustomAccordion {...{
                    title: isRTL === 'ar' ? val.arName || val.enName : val.enName || '---',
                    sectionId:val.id,
                    expandId,
                    setExpandId,
                    courseContents,
                    contentList: val?.['contentList'] || [],
                    isRTL,
                    t,
                    ...props,
                    childComponent: (
                    <div className={classes.colDiv} style={{width:'100%'}}>
                        {val?.['contentList']?.length ? React.Children.toArray(val?.['contentList'].map(v=> {
                            return(
                                <ContentAccordCard {...{
                                    fontFamily,
                                    t, 
                                    classes,
                                    isRTL,
                                    contentId:v,
                                    activeContentId,
                                    contentLogs,
                                    sideMenuContentClick,
                                    courseContents,
                                    ...props
                                }}/>
                            )
                        }))
                        : null
                        }
                    </div>
                    )
                }}/>
            )
        }))
        : null
        }
        </div>
        </>
      </Drawer>
  );
};

const mapDispatchToProps = dispatch => {
    return {
        logout_user : () => dispatch(remove_user()),
        change_lang : lang => dispatch(change_lang(lang)),
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        company: state.company,
        lang:state.lang,
        schoolId: state.schoolId,
        status: state.status,
        permission: state.permission,
        plans: state.plans,
        planId: state.planId,
        adminDemo: state.adminDemo,
        singleSession: state.singleSession
    };
};

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(withTranslation('common')(ContentSideMenu)));

function CustomAccordion(props) {
    const classes = accordionUseStyles();
    const { childComponent ,isRTL,contentList, expandId,setExpandId, sectionId, courseContents, title, rootCustomClass, accordionRootCustomCls, singleSession } = props;
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL ? ar : en;

    let contentExist = contentList?.length ? contentList?.filter(val=> courseContents?.filter(v=> v.id === val)?.[0]?.['visible']) : [];

    if(contentExist?.length) {
    return (
        <div className={`${classes.root} ${rootCustomClass}`}>
            <Accordion classes={{root:`${classes.accordionRoot} ${accordionRootCustomCls}`}}
                // onClick={()=> setPageId(pageId)}
                // onFocus={()=> setPageId(pageId)}
                // expanded={}
                // defaultExpanded={expandDefault || false}
                expanded={expandId === sectionId}
                onChange={()=> singleSession ? setExpandId(sectionId) : null}
            >
            <AccordionSummary
            expandIcon={<ExpandMore />}
            classes={{root:classes.accSumRoot,content:classes.accContent,expanded:classes.expandedCls,expandIcon:classes.expandIcon}}
            aria-controls="panel1a-content"
            id="panel1a-header"
            >
                <div className={classes.header}>
                    <span style={{fontFamily}} className={isRTL ? classes.marRight : classes.marLeft}>{title}</span>
                    <div className={classes.rowDiv}>
                    </div>
                </div>
            </AccordionSummary>
            <AccordionDetails classes={{root:classes.accDetail}}>
                {childComponent}
            </AccordionDetails>
        </Accordion>
        </div>
    );
    }

    return null;
};

function ContentAccordCard(props) {
    const { classes, fontFamily, contentId, courseContents, sideMenuContentClick, contentLogs, activeContentId, singleSession, t } = props;
    const filterContent = courseContents?.length ? courseContents.filter(val=> val.id === contentId)?.[0] : {};
    let { name, fileType, visible, markNewRelease } = filterContent || {};

    const isCompleted = contentLogs?.length ? contentLogs?.filter(v=> v.contentId === contentId)?.[0]?.['completed'] : false;

    if(visible)
    return(
        <div className={`${classes.rowDiv} ${classes.contentCard}`} style={{backgroundColor: contentId === activeContentId ? '#123950' : '',...(!singleSession ? {pointerEvents: 'none'} : {})}} onClick={()=> sideMenuContentClick(contentId,fileType)}>
            <div className={`${classes.rowDiv} ${classes.contentDiv}`}>
                <div className={classes.fileIcon}>
                    <img src={fileType === 'video' ? VideoLogo : fileType === 'document' ? DocLogo : fileType === 'externalLink' ? LinkLogo : fileType === 'quiz' ? QuizLogo : LinkLogo } alt={name} />
                </div>
                
                <span className={`${classes.drawerTitle} ${classes.contentName}`} style={{fontFamily,fontSize:'14px'}}>{name}</span>
            </div>

            {markNewRelease ? <span style={{fontFamily,color:'#36ABEF',fontSize:'12px'}}>{t && t('groupings.new')}</span> : null}
            <StyledCheckbox disabled checked={isCompleted}/>
        </div>
    );

    return null;
};